import React from 'react';
import './FingerDownImage.scss';
import iconDownHand from '../../../styles/assets/icons/pointer.svg';

export function FingerDownImage() {
  return (
    <div className='FingerDownImage'>
      <img src={iconDownHand} className='FingerDownImage__icon' alt='finger-down'/>
    </div>
  );
}
